<div class="backDrop center" *ngIf="showDialog" [style.backgroundColor]="noBackdrop ? 'rgba(0, 0, 0, 0)' : 'inherit'">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title text-center">Edit Json</h4>
			</div>

			<div class="modal-body">
				<json-editor [options]="jsonEditorOptions" [data]="jsonObject"></json-editor>
			</div>

			<div class="modal-footer">
				<button class="btn btn-ok btn-sm" (click)="onOkClick()">
					OK
				</button>
				<button class="btn btn-cancel btn-sm" (click)="onCancelClick()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
